var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5967",
    "data-name": "Group 5967",
    transform: "translate(10413 -5925)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_101",
    "data-name": "Ellipse 101",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(-10413 5925)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "language",
    transform: "translate(-10408 5930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_838",
    "data-name": "Group 838",
    transform: "translate(4.803 5.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_837",
    "data-name": "Group 837"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M121.028,137h-.256l-.479,2.4h1.214Z",
    transform: "translate(-120.293 -137)",
    fill: "#3f2566"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_840",
    "data-name": "Group 840",
    transform: "translate(15.229 10.262)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_839",
    "data-name": "Group 839"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M381.374,257a6.258,6.258,0,0,0,.983,1.736A6.321,6.321,0,0,0,383.381,257Z",
    transform: "translate(-381.374 -257)",
    fill: "#3f2566"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_842",
    "data-name": "Group 842",
    transform: "translate(9.69 3.634)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_841",
    "data-name": "Group 841"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M251.621,91h-7.438l1.551,12.446a1.859,1.859,0,0,1-.444,1.363l-2.627,3h8.958a1.8,1.8,0,0,0,1.8-1.8V92.837A1.833,1.833,0,0,0,251.621,91Zm0,6.629h-.16a7.6,7.6,0,0,1-1.443,2.624c.44.4.91.732,1.378,1.1a.6.6,0,0,1-.749.935c-.508-.4-.985-.737-1.462-1.175-.477.438-.914.774-1.423,1.175a.6.6,0,1,1-.749-.935c.468-.37.9-.7,1.338-1.1a7.56,7.56,0,0,1-1.4-2.624h-.16a.6.6,0,0,1,0-1.2h1.8v-.6a.6.6,0,0,1,1.2,0v.6h1.837a.6.6,0,1,1,0,1.2Z",
    transform: "translate(-242.663 -91)",
    fill: "#3f2566"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_844",
    "data-name": "Group 844",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_843",
    "data-name": "Group 843"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M9.75,1.574A1.8,1.8,0,0,0,7.967,0H1.8A1.8,1.8,0,0,0,0,1.8V15.054a1.8,1.8,0,0,0,1.8,1.8h9.446c.175-.2.321-.325.327-.586C11.572,16.2,9.758,1.639,9.75,1.574Zm-2.4,9.874a.6.6,0,0,1-.7-.47L6.257,9.064H4.564l-.383,1.914a.6.6,0,1,1-1.175-.235l1.2-5.99a.6.6,0,0,1,.587-.481H6.03a.6.6,0,0,1,.587.481l1.2,5.99A.6.6,0,0,1,7.345,11.449Z",
    transform: "translate(0)",
    fill: "#3f2566"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_846",
    "data-name": "Group 846",
    transform: "translate(6.998 18.049)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_845",
    "data-name": "Group 845"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M175.261,452l.1.822a1.811,1.811,0,0,0,1.036,1.392L178.41,452h-3.149Z",
    transform: "translate(-175.261 -452)",
    fill: "#3f2566"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglish);
export default __webpack_public_path__ + "static/media/English.8176ef740adfaee00a887b1ebf797d9a.svg";
export { ForwardRef as ReactComponent };